import { render, staticRenderFns } from "./NewProjectAdditionalStage.vue?vue&type=template&id=54c8cc9f&scoped=true&"
import script from "./NewProjectAdditionalStage.vue?vue&type=script&lang=js&"
export * from "./NewProjectAdditionalStage.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectAdditionalStage.vue?vue&type=style&index=0&id=54c8cc9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8cc9f",
  null
  
)

export default component.exports